import global from "../global.js";

// const log = global.log.getLogger("f_mtac.geolocation.debug");
const d3 = global.d3;

const GeolocationDebug = function(geolocation) {
    var recording = null;
    const get_line_points = (handle, path, interval) => {
        const path_node = path.node();
        const line_length = path_node.getTotalLength();
        const points_number = line_length / interval;
        return d3.range(points_number).map(d => {
            let {x, y} = path_node.getPointAtLength(d * interval);
            return [x, y];
        });
    };

    const random_noise = (R, X, Y) => {
        let a = Math.random() * 2 * Math.PI;
        let r = Math.sqrt(~~(Math.random() * R * R));
        let x = X + r * Math.cos(a);
        let y = Y + r * Math.sin(a);
        return [x, y];
    };

    global.geolocation_noise_presure = 20;
    const get_disk_points = (handle, disk, interval) => {
        var points = [];
        var R = parseFloat(disk.attr("r"));
        var X = parseFloat(disk.attr("cx"));
        var Y = parseFloat(disk.attr("cy"));
        for (let i = 0; i < interval; i++) {
            points.push(random_noise(R * Math.exp(- i / global.geolocation_noise_presure), X, Y));
        }
        return points;
    };

    const get_points = (local_id, interval) => {
        var points = [];
        const handle = d3.select(`#${local_id}`);
        if (handle.empty()) {
            return points;
        }
        const disk = handle.select("g.node.disk circle");
        if (!disk.empty()) {
            points = get_disk_points(handle, disk, interval);
        }
        const path = handle.select("g.node.line path");
        if (!path.empty()) {
            points = get_line_points(handle, path, interval);
        }
        const object = global.scene.objects.get_by_id("scene", local_id);
        global.scene.objects.tx_delete("scene", object);
        return points;
    };

    this.points_record_add_noise = (points, noise) => {
        let noised_points = [];
        for(let [x, y] of points) {
            noised_points.push(random_noise(noise, x, y));
        }
        return noised_points;
    };

    this.points_record = async (pixel_interval) => {
        const context = global.storage.selected_context;
        if (recording !== null) {
            return;
        }
        if (context.projection.project === null) {
            return;
        }
        recording = new Promise(resolve => {
            const on_create = ({local_id}) => {
                resolve(get_points(local_id, pixel_interval));
                context.off("objects", "creating", on_create);
                recording = null;
            };
            context.on("objects", "creating", on_create);
        });
        const points = await recording;
        return points;
    };

    this.points_simulate = async (points, time_interval) => {
        const context = global.storage.selected_context;
        const positions = [];
        for (let n = 0, t = 0; n < points.length; n++) {
            let [E, N] = context.projection.project.invert(points[n]);
            positions.push({timestamp: t, coords: {longitude: E, latitude: N}});
            t += time_interval;
        }
        let sleep = (t) => new Promise(resolve => setTimeout(resolve, t));
        let t0 = Date.now(), t = t0;
        for(let p of positions) {
            await sleep((t0 + p.timestamp) - t);
            t = t0 + p.timestamp;
            geolocation.simulate_position(p);
        }
    };
};

export default GeolocationDebug;
